// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__19w4C","header":"PatientBlock_header__3gevH","label":"PatientBlock_label__FU5jW","option":"PatientBlock_option__5t47I"};